export const BLINKING_OPACITY: number[] = [1, Math.random(), Math.random(), Math.random(), 1]
export const BLINKING_OPACITY_DURATION = 0.5
export const IS_WELCOME_GIF_SHOWED = false